import { render, staticRenderFns } from "./complaint-index.vue?vue&type=template&id=4ba7a118&scoped=true&"
import script from "./complaint-index.vue?vue&type=script&lang=js&"
export * from "./complaint-index.vue?vue&type=script&lang=js&"
import style0 from "./complaint-index.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./complaint-index.vue?vue&type=style&index=1&id=4ba7a118&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ba7a118",
  null
  
)

export default component.exports